var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0833 3H12.4583L11.7083 2.25H7.95825L7.20825 3H4.58325V4.5H15.0833M5.33325 14.25C5.33325 14.6478 5.49129 15.0294 5.77259 15.3107C6.0539 15.592 6.43543 15.75 6.83325 15.75H12.8333C13.2311 15.75 13.6126 15.592 13.8939 15.3107C14.1752 15.0294 14.3333 14.6478 14.3333 14.25V5.25H5.33325V14.25Z",
    fill: "#1C64F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.12fc3a7113b544fd21cb5794c5ead60d.svg";
export { ForwardRef as ReactComponent };